var operators;

operators = require('./binary-operators');

module.exports = operators({
  and: function(a, b) {
    return a && b;
  },
  or: function(a, b) {
    return a || b;
  }
});

module.exports.not = function(a) {
  return !a;
};
